export default {"src":"/_next/static/media/youtube-icon.7b75bfb9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};